import 'reflect-metadata'
global.executions = {
    lines: [],
    addLine: function (line) {
        if (!global.executions.enabled) return
        global.executions.lines = global.executions.lines.filter(function (v, i, a) { return a.length < 100 || i > 0; });
        global.executions.lines.push(line);
    },
    format: function (line, options = { relativePath: false }) {
        const enabled = global.executions.enabled
        global.executions.enabled = false
        const path = require('path') as typeof import('path')
        const chalk = require('chalk') as typeof import('chalk')
        const Server = (require("../backend/server") as typeof import('../backend/server')).default
        const Colors = require('../shared/utils/colors') as typeof import('../shared/utils/colors')
        const format = `${line.className ? chalk.hex('#ff1744')(`<${line.className.replace(/^\</g, '').replace(/\>$/g, '')}>`) : chalk.hex('#ff1744')(`<global>`)} → ${[...line.hierarchy].filter((v, i) => i > 1).reverse().filter((v, i) => i < 5).reverse().map((v, i) => {
            return chalk.hex(Colors.default.shiftHue('#dd4a67', 10 * i))(v)
        }).join(' → ')} ${chalk.hex('#999999')(`<${options.relativePath ? line.fileName : path.join(Server.root, line.fileName.replace(/^\./, ''))}:${chalk.hex('#46b36f').bold(line.childLine)}>`)}`
        global.executions.enabled = enabled
        return format
    },
    formatAll: function() {
        return [...global.executions.lines].reverse().map((v) => global.executions.format(v)).join(',')
    },
    enabled: false,
    ignore: (async(data) => {
        global.executions.enabled = false
        const resolved = await data()
        global.executions.enabled = true
        return resolved
    }) as typeof global.executions.ignore
};
global.executions.ignore.includingThisLine = <T>(data: T) => {
    global.executions.lines = global.executions.lines.filter((v, i, a) => i !== a.length - 1)
    return global.executions.ignore(data as any)
}
import('../config/env').then(() => {
    const chalk = require('chalk') as typeof import('chalk')
    const Server = (require("../backend/server") as typeof import('../backend/server')).default
    const paths = require('../config/paths') as typeof import('../config/paths')
    Server.root = paths.locateProject(process.cwd())!;
    const consoleFunctions: (keyof typeof console)[] = ['log', 'info', 'warn', 'error', 'debug', 'trace', 'verbose']
    let last = ''
    for (const consoleFunctionName of consoleFunctions) {
        global.executions.enabled = false
        const originalConsoleFunction = console[consoleFunctionName]
        console[consoleFunctionName] = ((...args: any[]) => {
            args = args.map((v) => typeof v === 'string' ? v.replace(/^(\s+)/, '') : v)
            if (global.executions.lines.length) {
                const line = [...global.executions.lines].reverse().find((v) => true)
                if (line) {
                    process.stdout.write(Buffer.from('\n', 'utf8'));
                    const current = global.executions.format(line, { relativePath: false })
                    if (current === last) {
                        (originalConsoleFunction as any)(...args)
                    }
                    else {
                        (originalConsoleFunction as any)(current);
                        process.stdout.write(Buffer.from('\n', 'utf8'));
                        (originalConsoleFunction as any)(...args);
                        last = current
                    }
                }
            }
            else {
                process.stdout.write(Buffer.from('\n', 'utf8'));
                (originalConsoleFunction as any)(...args)
            }
        }) as any
        global.executions.enabled = true
    }
    const consoleError = console.error
    console.error = (...args: any[]) => {
        global.executions.enabled = false
        const errorArg = [args].flat().find((v) => v instanceof Error)
        const message = errorArg ? chalk.bgHex('#80162b').hex('#D7d7d7').bold(' ' + errorArg.constructor.name + ' ') + '\n' + errorArg.message + '\n' : null
        const hasError = !!args.find((v) => v instanceof Error)
        if (hasError) {
            consoleError(
                ...[
                    ...args
                        .filter((v) => 
                            !hasError || !(v instanceof Error)
                        ),
                        (message ? message : '') + global.executions.lines
                            .filter((v, i, a) => i > a.length - 11)
                            .reverse()
                            .map((v) =>
                                '  ' +
                                global.executions.format(v).trim()).join('\n') +
                                (
                                    errorArg?.stack
                                    ?   `\n\n${chalk.bgHex('#80162b').hex('#D7d7d7').bold(` Original `)}\n` + 
                                        `${errorArg?.stack.replace(/^.*\n(\s+)at/, ' ').replace(/(\n)(\s+)at/gms, '\n ').replace(/(?<=→)([^→]+)/gms, (_: string, g1: string) => {
                                            return chalk.hex('#999999')(g1)
                                        })}`
                                    : ''
                                )
                ]
            )
        }
        else {
            consoleError(...args)
        }
        global.executions.enabled = true
    }
    const HandledPromise = require("../backend/models/handled-promise") as typeof import('../backend/models/handled-promise');
    HandledPromise.default<void>(async(res, rej) => {
        const server = new Server()
        await server.listen().then(() => {
            console.error(1244)
        })
    })
})
